import { content } from './content/index.js';
export const cardPresentationCatalog = content.catalog;
export const deckCatalog = content.decks;
export function getCardPresentation(cardId) {
    return cardPresentationCatalog.get(cardId);
}
export function listDeckDefinitions() {
    return deckCatalog;
}
export function listAvailableDecks(catalog = deckCatalog) {
    return catalog.filter((definition) => definition.availability === 'available');
}
export function getDeckDefinition(deckDefinitionId, catalog = deckCatalog) {
    return catalog.find((definition) => definition.id === deckDefinitionId);
}
export function validateDeckDefinition(definition, knownCardIds = cardPresentationCatalog.keys()) {
    if (definition.id.length === 0)
        throw new Error('DeckDefinition.id должен быть непустой строкой');
    if (definition.cardIds.length !== 12) {
        throw new Error(`DeckDefinition "${definition.id}" должен содержать ровно 12 CardDefId`);
    }
    const unique = new Set(definition.cardIds);
    if (unique.size !== 12) {
        throw new Error(`DeckDefinition "${definition.id}" должен содержать 12 уникальных CardDefId`);
    }
    const known = new Set(knownCardIds);
    const unknown = definition.cardIds.filter((cardId) => !known.has(cardId));
    if (unknown.length > 0) {
        throw new Error(`DeckDefinition "${definition.id}" содержит неизвестные CardDefId: ${unknown.join(', ')}`);
    }
}
export function buildStartingDeck(definition, knownCardIds = cardPresentationCatalog.keys()) {
    if (definition.availability !== 'available') {
        throw new Error(`DeckDefinition "${definition.id}" недоступен для старта`);
    }
    validateDeckDefinition(definition, knownCardIds);
    const result = definition.cardIds.flatMap((cardId) => [cardId, cardId]);
    if (result.length !== 24)
        throw new Error(`стартовая колода "${definition.id}" должна содержать 24 карты`);
    for (const cardId of definition.cardIds) {
        if (result.filter((candidate) => candidate === cardId).length !== 2) {
            throw new Error(`стартовая колода "${definition.id}" должна содержать две копии "${cardId}"`);
        }
    }
    return result;
}
//# sourceMappingURL=catalog.js.map